import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import UsersSerialsContext from './contexts/users-serials-context';
import useUsersSerials from './hooks/users-serials';

import AuthContext from './contexts/auth-context';
import useAuth from './hooks/auth';

import LoginPage from './components/login';
import RegisterPage from './components/register';
import UsersSerials from './components/users-serials';
import ProductPage from './components/register-product';
import PinsReport from './components/pins-report';

function App() {
  return (
    <div className='App'>
      <Router>
        <Switch>
          <AuthContext.Provider value={{ ...useAuth() }}>
            <UsersSerialsContext.Provider value={{ ...useUsersSerials() }}>
              {
                window.location.pathname === '/' && <Redirect to='/login' />
              }
              <Route exact={true} path='/login'>
                <LoginPage />
              </Route>
              <Route exact={true} path='/register'>
                <RegisterPage />
              </Route>
              <Route exact={true} path='/register-product'>
                <ProductPage />
              </Route>
              <Route path='/users-serials'>
                <UsersSerials />
              </Route>
              <Route exact={true} path='/report'>
                <PinsReport />
              </Route>
              <Route exact={true} path='/logout'>
                <LoginPage />
              </Route>
            </UsersSerialsContext.Provider>
          </AuthContext.Provider>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
